<template>
    <div id="customOrganizationPage" class="login-container" v-bind:style="getBackgroundCss">
        <loader class="color" v-if="$store.state.loginPage.loading"></loader>
        <div class="login-panel">
            <img :src="logo" alt="Navitas Group">
            <text-input label="E-mail / Username" hint="If you confirmed email, login with it, not username."
                        ref="username" @keyup.enter.native="actionLogin"/>
            <password-input label="Password" ref="password" @keyup.enter.native="actionLogin"/>
            <text-button style="transition: 0ms" label="Sign in" :loading-state="loadingState" @click="actionLogin"/>
            <div class="forgot-password-link">
                <a @click="actionForgotPassword">Forgot your password?</a>
            </div>
        </div>
    </div>

</template>
<script>
    import Login from "@/old/pages/Login";
    import customLoginPageMixin from "@/new/pages/OrganizationLogin/customLoginPageMixin";
    import Loader from "@/old/components/Loader";

    export default {
        name: "Login",
        components: {Loader},
        mixins: [Login, customLoginPageMixin],
        methods: {
            /**
             * Using router name not from enum because params work only with named routes!
             * https://router.vuejs.org/guide/essentials/navigation.html
             */
            actionForgotPassword() {
                this.$router.push({
                    name: 'CustomOrganizationForgotPassword',
                    params: {organization: this.$route.params.organization}
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .loader {
        background: whitesmoke;
        z-index: 2;
    }
</style>
